/**
 * Card-item adapter for CodeStitch pinned card grids (`div.cs-card-group`).
 *
 * Items are `.cs-grid-item` (either `picture.cs-image` or `div.cs-card`) pinned
 * to explicit grid cells by an ordinal class `cs-item1…N`. Because position is
 * bound to the ordinal class — NOT DOM order — a bare DOM move is visually
 * inert, so `postMoveNormalize` renumbers `cs-itemN` to the new DOM order after
 * every move. `reorderAxis:'grid'` selects 2D nearest-cell hit-testing.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';
import { normalizeOrdinalClasses } from '../ordinal-normalize.js';

export const cardItemAdapter = {
  kind: 'card-item',
  label: 'Card',
  itemSelector: '.cs-grid-item',
  parentSelector: '.cs-card-group',
  reorderSelector: '.cs-card-group > .cs-grid-item',
  reorderSiblingSelector: '.cs-card-group > .cs-grid-item',
  reorderAxis: 'grid',
  historyLabel: 'Reorder card',
  toastText: 'Card reordered',
  vtPrefix: 'pb-card-',
  vtSelector: '.cs-card-group > .cs-grid-item',
  moveFn: moveSiblingPreservingEids,
  // Renumber cs-itemN after the DOM move. No-op for a non-pinned card grid.
  postMoveNormalize(sectionHtml, ctx) {
    return normalizeOrdinalClasses(sectionHtml, {
      anchorEid: ctx?.sourceEid,
      parentSelector: ctx?.parentSelector || '.cs-card-group',
      ordinalPrefix: 'item',
      normalizeAll: ctx?.normalizeAll === true
    });
  },
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    if (!probe.closest('.cs-card-group')) return null;
    return probe.closest('.cs-grid-item');
  }
};
